import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { messagingQueryKeys } from '@/modules/messaging/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

interface SendDraftMessageParams {
  threadId: string;
  messageId: string;
}

export const useSendDraftMessageMutation = () => {
  return useMutation({
    mutationFn: ({ threadId, messageId }: SendDraftMessageParams) =>
      fetchClient.PUT('/message-threads/{threadId}/messages/{id}/send', {
        params: {
          path: {
            id: messageId,
            threadId,
          },
        },
      }),
    onSettled: (_, __, { threadId, messageId }) => {
      invalidateQuery(messagingQueryKeys.threadMessage(threadId, messageId))();
      invalidateQuery(messagingQueryKeys.messages(['Draft']))();
    },
  });
};
